'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToCamelCase = convertToCamelCase;

var _capitalize = require('./capitalize');

/**
 * @description Converts the given string to camelCase.
 * @summary
 * This method takes a string in kebab-case or snake_case and converts it
 * to camelCase.
 *
 * The second argument allows specifying a custom divider regex that is used to split
 * the string into parts. This can be used, if the string has a non-standard casing
 * or is split in ways that are non-standard.
 *
 *
 * @example
 * import { convertToCamelCase } from '@nimius/string-utility';
 *
 * convertToCamelCase('kebab-cased-string');
 * // => 'kebabCasedString'
 *
 * convertToCamelCase('snake_cased_string');
 * // => 'snakeCasedString'
 *
 * convertToCamelCase('string with spaces');
 * // => 'stringWithSpaces'
 *
 *
 * @example <caption>Custom divider</caption>
 * import { convertToCamelCase } from '@nimius/string-utility';
 *
 * convertToCamelCase('string#divided-by#hashes', '#');
 * // => stringDivided-byHashes
 *
 * convertToCamelCase('string#divided-by#hashes', /[#-]/);
 * // => stringDividedByHashes
 *
 *
 * @param {string} string - The string that should be converted to camelCase.
 * @param {string|RegExp} [divider=/[-_W]/] - Regular expression that is used to split the parts of the String.
 * @returns {string|*} - The camelCased string.
 */
function convertToCamelCase(string) {
    var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /[-_\W]/;

    return string.split(divider).map(function (part, index) {
        // Do not capitalize the first part
        if (index === 0) {
            return part;
        }
        return (0, _capitalize.capitalize)(part);
    }).join('');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/string-utility/src/convert-to-camel-case.js
// module id = 65
// module chunks = 0 2